import { Product } from "../../types/types";
import { useVariant } from "../useVariant/useVariant";
import { useRouter } from "next/router";
import { getSizeQuery } from "../../utils/routing/getSizeQuery";

export const useSeo = (product: Product) => {
  const { variant, isSelected } = useVariant(product);
  const router = useRouter();
  const hasSizeInQuery = !!getSizeQuery(router.query);
  const isPathnameAProductCanonical =
    router.asPath.split("?")[0]?.split("#")[0] === product.canonicalURL;

  if (
    (isPathnameAProductCanonical && hasSizeInQuery && !isSelected) ||
    (isPathnameAProductCanonical && !hasSizeInQuery)
  ) {
    return {
      title: product.seo.browserTitle,
      heading: product.seo.pageHeading,
    };
  } else if (isSelected) {
    return { title: variant.title, heading: variant.title };
  } else {
    return {
      title: `${product.seo.browserTitle}${
        variant.differentiators?.colour
          ? `, ${variant.differentiators.colour}`
          : ""
      }`,
      heading: `${product.seo.pageHeading}${
        variant.differentiators?.colour
          ? `, ${variant.differentiators.colour}`
          : ""
      }`,
    };
  }
};
